(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('NasracAdminUserAccountDeleteController',NasracAdminUserAccountDeleteController);

    NasracAdminUserAccountDeleteController.$inject = ['$uibModalInstance', 'entity', 'NasracAdminUserAccount'];

    function NasracAdminUserAccountDeleteController($uibModalInstance, entity, NasracAdminUserAccount) {
        var vm = this;

        vm.nasracAdminUserAccount = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            NasracAdminUserAccount.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
